import { render, staticRenderFns } from "./RoleTable.vue?vue&type=template&id=c0ed40a6"
import script from "./RoleTable.vue?vue&type=script&lang=js"
export * from "./RoleTable.vue?vue&type=script&lang=js"
import style0 from "./RoleTable.vue?vue&type=style&index=0&id=c0ed40a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports